import { Box, CircularProgress, Backdrop } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from "notistack";
import 'react-international-phone/style.css';
import ModalComponent from "../../../../components/modals/modalComponent";
import SharedBlockChainAccCreation from "../../../../components/modals/common/SharedBlockChainAccCreation";


export default function TrustCreateDLTModel({ open, setOpen, trust, getTrustDetails ,disableAlgorandOption = true ,disablePolygonOption = false, disableMstOption = false }) {

    const [blockchainAccountDownload, setBlockchainAccountDownload] = useState(false);
    const [blockchainAccountCreated, setBlockchainAccountCreated] = useState(false);
    const [animating, setAnimating] = useState(false);
    const dispatch = useDispatch();
    const [openProgressBar, setOpenProgressBar] = useState(false);
    const [sendMail, setSendMail] = useState(true);
    const modelRef = useRef();
    const { enqueueSnackbar } = useSnackbar();
    const user = useSelector(state => state.user.data)

    useEffect(() => {
        if (trust?.status !== "KYC_APPROVED" && trust?.status !== "APPROVED") {
            setOpen(false);
        }
    }, [trust?.status]);

    useEffect(() => {
        if (animating) {
            scrollToTop();
        }
    }, [animating])

    const customHandleClose = () => {
        if (!blockchainAccountCreated || blockchainAccountDownload) {
            setOpen(false);
            setBlockchainAccountCreated(false);
        }
        else enqueueSnackbar("Please download key details before closing!", { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, autoHideDuration: 5000 })
    }

    const scrollToTop = () => {
        if (modelRef.current) {
            let modalBody = modelRef.current.querySelector('.MuiDialog-container')
            if (modalBody) {
                modalBody.scroll({
                    top: 0,
                    behavior: 'smooth'
                });
            }
        }
    }

    return (
        <ModalComponent
            slotProps={{
                root: {
                    ref: modelRef
                }
            }}
            open={open}
            handleClose={customHandleClose}
            PaperProps={{ sx: { textAlign: "center", overflow: "auto", width: { md: 480 }, maxWidth: "100%" } }}
            contentPadding={{ xs: 1, md: 1.25 }}>
            <Backdrop open={openProgressBar} sx={{ color: "#ddd", zIndex: (theme) => theme.zIndex.drawer + 1 }}>
                <CircularProgress
                    size={75}
                    thickness={4}
                    sx={{
                        position: "fixed",
                        left: "50%",
                        top: "50%",
                        transform: "translate(-50%, -50%)",
                        zIndex: 2
                    }}
                    style={{ color: "#fff" }}
                />
            </Backdrop>
            <SharedBlockChainAccCreation
                entity={trust}
                entityType="TRUST"
                customHandleClose={customHandleClose}
                setAnimating={setAnimating}
                setBlockchainAccountDownload={setBlockchainAccountDownload}
                blockchainAccountCreated={blockchainAccountCreated}
                setBlockchainAccountCreated={setBlockchainAccountCreated}
                onAccountCreated={() => getTrustDetails()}
                onAccountDownloaded={() => getTrustDetails()}
                disableAlgorandOption={true}
                disablePolygonOption={disablePolygonOption || !user?.dltPolicy?.polygon}
                disableMstOption={disableMstOption || !user?.dltPolicy?.mst}
                nicknamePlaceholder="Nick name"
                sendMail={sendMail}
                setSendMail={setSendMail}
            />
        </ModalComponent>
    )
}